import { provideConfig } from '@spartacus/core'
import { NgModule } from '@angular/core'

@NgModule({
  providers: [
    provideConfig({
      featureModules: {
        linkWrapperFeature: {
          module: () => import('./link-wrapper.module').then((m) => m.LinkWrapperModule),
        },
      }
    })
  ]
})
export class LinkWrapperFeatureModule {}
